export default __webpack_public_path__ + "static/media/004-youtube.4002473d.svg";